<!-- src/components/Login.vue -->
<template>
  <div class="login-container" :style="{ backgroundImage: `url(${backgroundImage})` }">

    <!-- 波浪背景 -->
    <div class="particles" ref="particlesContainer"></div>


    <!-- 登录注册卡片 -->
    <el-card class="login-card" shadow="hover">
      <h2 class="login-title">
        <span class="gradient-text">{{ isRenew ? '站点续费' : isRegister ? '站点注册' : '站点登录' }}</span>
      </h2>

      <!-- 登录表单 -->
      <el-form v-if="!isRegister && !isRenew" :model="loginForm" ref="loginFormRef" :rules="rules">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="账号" clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <User />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div> <!-- 预留错误提示空间 -->

        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="密码" show-password clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <Lock />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div> <!-- 预留错误提示空间 -->

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading" class="login-btn">
            立即登录
          </el-button>
        </el-form-item>

        <div class="toggle-text">
          没有站点？<el-link type="primary" @click="switchToRegister">立即注册</el-link>
        </div>
      </el-form>

      <!-- 注册表单 -->
      <el-form v-else-if="isRegister" :model="registerForm" ref="registerFormRef" :rules="registerRules">
        <el-form-item prop="account">
          <el-input v-model="registerForm.account" placeholder="账号" clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <User />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div> <!-- 预留错误提示空间 -->

        </el-form-item>

        <el-form-item prop="mobile">
          <el-input v-model="registerForm.mobile" placeholder="手机号" clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <Phone />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div> <!-- 预留错误提示空间 -->

        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="registerForm.password" type="password" placeholder="密码" show-password clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <Lock />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div> <!-- 预留错误提示空间 -->

        </el-form-item>

        <el-form-item prop="confirmPassword">
          <el-input v-model="registerForm.confirmPassword" type="password" placeholder="确认密码" show-password clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <Lock />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div> <!-- 预留错误提示空间 -->

        </el-form-item>

        <el-form-item prop="registerCode">
          <el-input v-model="registerForm.registerCode" placeholder="注册码" clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <Message />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div> <!-- 预留错误提示空间 -->

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleRegister" :loading="loading" class="login-btn">
            立即注册
          </el-button>
        </el-form-item>

        <div class="toggle-text">
          <el-link type="primary" @click="switchToLogin">
            返回登录
          </el-link>
        </div>
      </el-form>


      <!-- 续费表单 -->
      <el-form v-else :model="renewForm" ref="renewFormRef" :rules="renewRules">
        <el-form-item prop="account">
          <el-input v-model="renewForm.account" placeholder="请输入您的站点账号" clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <User />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div>
        </el-form-item>

        <el-form-item prop="activationCode">
          <el-input v-model="renewForm.activationCode" placeholder="请输入激活码" clearable>
            <template #prefix>
              <el-icon class="input-icon">
                <Key />
              </el-icon>
            </template>
          </el-input>
          <div class="error-tip-space"></div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleRenew" :loading="loading" class="login-btn">
            立即续费
          </el-button>
        </el-form-item>

        <div class="toggle-text">
          <el-link type="primary" @click="switchToLogin">
            返回登录
          </el-link>
        </div>
      </el-form>

      <!-- 修改底部操作链接 -->
      <div class="action-links" v-if="!isRenew && !isRegister">
        <el-link type="primary" @click="switchToRenew">站点续费</el-link>
        <el-divider direction="vertical" />
        <el-link type="primary" @click="switchToRegister">
          没有站点？注册
        </el-link>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'

import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import md5 from 'md5'
import Cookies from 'js-cookie'
import config from '@/config'
import { User, Lock, Phone, Message, Key } from '@element-plus/icons-vue'

export default {
  name: 'LawyerLogin',
  components: {
    User,
    Lock,
    Phone,
    Message,
    Key
  },
  setup() {
    const router = useRouter()
    const isRegister = ref(false)
    const isRenew = ref(false)
    const backgroundImage = ref('') // 添加背景图状态

    // 登录相关状态
    const loginForm = ref({
      username: '',
      password: ''
    })

    // 注册相关状态
    const registerForm = ref({
      account: '',
      mobile: '',
      password: '',
      confirmPassword: '',
      registerCode: ''
    })

    // 续费相关状态
    const renewForm = ref({
      account: '',
      activationCode: ''
    })

    const loading = ref(false)
    const loginFormRef = ref(null)
    const registerFormRef = ref(null)
    const particlesContainer = ref(null)
    const renewFormRef = ref(null)

    // 获取背景图配置
    const fetchBackgroundConfig = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)

        if (response.data.success && response.data.data.shop_bg) {
          backgroundImage.value = response.data.data.shop_bg
        } else {
          // 使用默认背景
          backgroundImage.value = 'https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250929/20250929223930fc1941640.png'
        }
      } catch (error) {
        console.error('获取背景配置失败:', error)
        // 使用默认背景
        backgroundImage.value = 'https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250929/20250929223930fc1941640.png'
      }
    }

    // 续费表单验证规则
    const renewRules = {
      account: [
        { required: true, message: '⚠️ 请输入账号', trigger: 'blur' },
        { min: 6, message: '⚠️ 账号长度至少6位', trigger: 'blur' }
      ],
      activationCode: [
        { required: true, message: '⚠️ 请输入激活码', trigger: 'blur' }
      ]
    }

    const switchToRegister = () => {
      isRegister.value = true
      isRenew.value = false
    }

    const switchToRenew = () => {
      isRenew.value = true
      isRegister.value = false
    }

    const switchToLogin = () => {
      isRegister.value = false
      isRenew.value = false
    }

    // 续费处理
    const handleRenew = async () => {
      try {
        await renewFormRef.value.validate()
        loading.value = true

        const response = await axios.post(`${config.BASE_URL}/shop/api/recharge.php`, {
          account: renewForm.value.account,
          activation_code: renewForm.value.activationCode
        })

        if (response.data.code === 200) {
          ElMessage.success(response.data.message)
          // 显示续费成功信息
          ElMessage.success(`续费成功！新到期时间: ${response.data.data.new_out_date}`)
          // 重置表单
          renewForm.value = { account: '', activationCode: '' }
          isRenew.value = false
        } else {
          ElMessage.error(response.data.message || '续费失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '网络连接异常')
      } finally {
        loading.value = false
      }
    }

    // 表单验证规则
    const rules = {
      username: [{ required: true, message: '⚠️ 请输入账号', trigger: 'blur' }],
      password: [{ required: true, message: '⚠️ 请输入密码', trigger: 'blur' }]
    }


    const validatePassword = (rule, value, callback) => {
      if (value !== registerForm.value.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }

    const registerRules = {
      account: [
        { required: true, message: '⚠️ 请输入账号', trigger: 'blur' },
        { min: 6, message: '⚠️ 账号长度至少6位', trigger: 'blur' }

      ],
      mobile: [
        { required: true, message: '⚠️ 请输入手机号', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '⚠️ 手机号格式不正确', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '⚠️ 请输入密码', trigger: 'blur' },
        { min: 6, message: '⚠️ 密码长度至少6位', trigger: 'blur' }
      ],
      confirmPassword: [
        { required: true, message: '⚠️ 请再次输入密码', trigger: 'blur' },
        { validator: validatePassword, trigger: 'blur' }
      ],
      registerCode: [
        { required: true, message: '⚠️ 请输入注册码', trigger: 'blur' }
      ]
    }
    // 粒子生成函数
    const createParticles = () => {
      const container = particlesContainer.value;
      if (!container) return;

      container.innerHTML = '';

      // 增加粒子密度
      const particleCount = Math.floor((container.clientWidth * container.clientHeight) / 1500);

      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        const size = Math.random() > 0.7 ? 'large' : (Math.random() > 0.3 ? 'medium' : 'small');

        particle.classList.add('particle', size);

        // 从底部区域生成粒子
        const posX = Math.random() * 100;
        const posY = 70 + Math.random() * 30;

        particle.style.left = `${posX}%`;
        particle.style.top = `${posY}%`;
        particle.style.animationDelay = `${Math.random() * 5}s`;
        particle.style.animationDuration = `${8 + Math.random() * 12}s`; // 延长动画时间
        particle.style.opacity = Math.random() * 0.6 + 0.4; // 提高透明度范围

        container.appendChild(particle);
      }
    }
    onMounted(() => {
      console.log('Component mounted');
      console.log('Particles container:', particlesContainer.value);
      createParticles();
      window.addEventListener('resize', createParticles);
      fetchBackgroundConfig() // 在组件挂载时获取背景配置

    });
    // 登录处理
    const handleLogin = () => {
      loginFormRef.value.validate(async (valid) => {
        if (!valid) return

        loading.value = true
        try {
          const response = await axios.post(
            `${config.BASE_URL}/shop/api/login.php`,
            {
              account: loginForm.value.username,
              password: md5(loginForm.value.password)
            }
          )

          if (response.data.code === 200) {
            Cookies.set('user_token', response.data.data.id, { expires: 7 })
            Cookies.set('user_info', JSON.stringify(response.data.data), { expires: 7 })
            ElMessage.success(response.data.message)
            router.push('/Dashboard')
          } else {
            const errorMessages = {
              400: '请输入完整的账号密码',
              401: '账号或密码错误',
              403: response.data.message,
              500: '服务器错误，请稍后再试'
            }
            ElMessage.error(errorMessages[response.data.code] || '登录失败')
          }
        } catch (error) {
          ElMessage.error(error.response ? '登录失败，请重试' : '网络连接异常')
        } finally {
          loading.value = false
        }
      })
    }

    // 注册处理
    const handleRegister = () => {
      registerFormRef.value.validate(async (valid) => {
        if (!valid) return

        loading.value = true
        try {
          const response = await axios.post(
            `${config.BASE_URL}/shop/api/register.php`,
            {
              account: registerForm.value.account,
              mobile: registerForm.value.mobile,
              password: md5(registerForm.value.password),
              invitation_code: registerForm.value.registerCode
            }
          )

          if (response.data.code === 200) {
            ElMessage.success('注册成功')
            isRegister.value = false
            // 清空注册表单
            registerForm.value = {
              account: '',
              mobile: '',
              password: '',
              confirmPassword: '',
              registerCode: ''
            }
          } else {
            const errorMessages = {
              400: '注册信息不完整',
              401: '注册码无效',
              403: '注册用户已达上限',
              409: '站点已存在',
              500: '服务器错误'
            }
            ElMessage.error(errorMessages[response.data.code] || '注册失败')
          }
        } catch (error) {
          ElMessage.error(error.response ? '注册失败，请重试' : '网络连接异常')
        } finally {
          loading.value = false
        }
      })
    }

    return {
      isRegister,
      isRenew,
      loginForm,
      registerForm,
      renewForm,
      rules,
      registerRules,
      renewRules,
      loginFormRef,
      registerFormRef,
      renewFormRef,
      loading,
      particlesContainer,
      backgroundImage, // 返回背景图状态
      handleLogin,
      handleRegister,
      handleRenew,
      switchToRegister,
      switchToRenew,
      switchToLogin
    }
  }
}
</script>



<style scoped>
.toggle-text {
  text-align: center;
  margin-top: 15px;
  color: #666;
}

.toggle-text .el-link {
  vertical-align: baseline;
}

/* 新增样式 */
.action-links {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.action-links .el-link {
  margin: 0 10px;
}


.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background: no-repeat center center;
  /* 移除固定背景图 URL */
  background-size: cover;
  transition: background-image 0.5s ease-in-out;
  /* 添加过渡效果 */
}

/* 背景图暗化层 */
.login-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  /* 调整这个值控制暗化程度 */
  z-index: 1;
  /* 保持暗化层在最底层 */

}

/* 粒子效果容器 */
.particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  /* 粒子在暗化层之上 */
  box-shadow: 0 0 6px rgba(100, 180, 255, 0.8);
  /* 添加发光效果 */
  overflow: hidden;


}

/* 单个粒子样式 */
.particle {
  position: absolute;
  background: rgba(100, 150, 255, 0.8);
  /* 更亮的蓝色 */
  border-radius: 50%;
  pointer-events: none;
  animation: float 15s infinite linear;
}

/* 增大粒子尺寸 */
.particle.small {
  width: 4px;
  height: 4px;
}

.particle.medium {
  width: 6px;
  height: 6px;
}

.particle.large {
  width: 8px;
  height: 8px;
}

/* 优化动画路径 */
@keyframes float {
  0% {
    transform: translateY(0) translateX(0);
    opacity: 0;
  }

  10% {
    opacity: 0.8;
    /* 更早显示 */
  }

  90% {
    opacity: 0.8;
    /* 更晚消失 */
  }

  100% {
    transform: translateY(-100vh) translateX(50px);
    /* 更垂直的路径 */
    opacity: 0;
  }
}

/* 确保粒子容器可见 */
.particles {
  pointer-events: none;
  /* 防止粒子拦截点击事件 */
}

.login-card {
  width: 420px;
  padding: 40px 35px;
  border-radius: 12px;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.3),
    0 0 15px rgba(72, 114, 255, 0.2);
  transform: translateY(-10%);
  z-index: 3;
  /* 登录卡片在最顶层 */
  position: relative;
  background: rgba(15, 23, 42, 0.9);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(72, 114, 255, 0.2);
}

.login-title {
  text-align: center;
  margin-bottom: 35px;
  font-size: 24px;
  font-weight: 600;
  position: relative;
}

.gradient-text {
  background: linear-gradient(90deg, #4772ff, #8a2be2, #4772ff);
  background-size: 200% auto;
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  animation: gradient 3s linear infinite;
  text-shadow: 0 0 10px rgba(71, 114, 255, 0.3);
}

@keyframes gradient {
  0% {
    background-position: 0% center;
  }

  100% {
    background-position: 200% center;
  }
}

.input-icon {
  color: #64748B;
  font-size: 18px;
  margin-left: 4px;
}

:deep(.el-input__inner) {
  height: 48px;
  border-radius: 8px;
  transition: all 0.3s;
  color: #f7f4f4;
}

:deep(.el-input__inner):focus {
  border-color: #4772ff;
}

:deep(.el-input__prefix) {
  left: 12px;
  display: flex !important;
  align-items: center;
  height: 100%;
}

.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4772ff, #5851ff);
  border: none;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(72, 114, 255, 0.3);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(72, 114, 255, 0.4);
}

/* 响应式调整 */
@media (max-width: 480px) {
  .login-card {
    width: 90%;
    padding: 30px 20px;
  }
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 28px !important;
  /* 增加底部间距 */
}

/* 登录按钮上方的表单项间距 */
.el-form-item:last-child {
  margin-bottom: 20px !important;
}

/* 在style部分添加以下样式 */
:deep(.el-form-item__error) {
  color: #ff4d4f !important;
  font-size: 14px;
  font-weight: 500;
  padding-top: 4px;
  background: rgba(255, 77, 79, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 4px;
  display: inline-block;
}

/* 错误状态下输入框样式 */
:deep(.el-input.is-error .el-input__wrapper) {
  box-shadow: 0 0 0 1px #ff4d4f !important;
  background-color: rgba(255, 77, 79, 0.05);
}

/* 添加错误提示动画 */
@keyframes shakeError {

  0%,
  100% {
    transform: translateX(0);
  }

  15%,
  45%,
  75% {
    transform: translateX(-5px);
  }

  30%,
  60%,
  90% {
    transform: translateX(5px);
  }
}

:deep(.el-form-item.is-error .el-input__wrapper) {
  animation: shakeError 0.4s ease-in-out;
}

.form-item-with-error {
  position: relative;
}

.error-tip-space {
  height: 24px;
  /* 为错误提示预留固定空间 */
  visibility: hidden;
}

/* 错误时显示预留空间 */
.is-error .error-tip-space {
  visibility: visible;
}
</style>